module.exports = __webpack_public_path__ + "static/Hero-9e23d1bf1a90b1721ad0fca5008bc620.png";